import BitconImg from './assets/img/solarify.png'
import EthereumImg from './assets/img/electrify.jpg';
import LitecoinImg from './assets/img/zerofy.webp';

export const navData = [
    {
        name: 'Products',
        href: '#/',
    },
    {
        name: 'Features',
        href: '#/',
    },
    {
        name: 'About',
        href: '#/',
    },
    {
        name: 'Contact',
        href: '#/',
    },
];

export const currency = [
    {
        image: BitconImg,
        name: 'Solarify',
        abbr: '',
        description:
            'Harness the power of the sun with our customized solar solutions for your home or business, guided by our expert team from start to finish. Generate clean energy, reduce your carbon footprint, and save money on your energy bills.',
    },
    {
        image: EthereumImg,
        name: 'Electrify',
        abbr: '',
        description:
            'Elevate your electric vehicle charging experience with our customized solutions for your home or business. Our expert team will design and implement a reliable and hassle-free charging infrastructure tailored to your needs.',
    },
    {
        image: LitecoinImg,
        name: 'Zerofy',
        abbr: '',
        description:
            'Create your eco-friendly dream home with our net-zero building services. Our team will design and construct an energy-efficient home using the latest technologies and building practices for a net-zero energy balance.',
    },
];